<div
  class="w-full h-[4.5rem] bg-white border-b border-slate-200 flex items-center gap-4 px-4 md:px-6"
  [style.box-shadow]="hasSidebar ? '6px 5px 10px #e4e4e4' : null"
>
  @if (!hasSidebar) {
    @if (isHomeSelector()) {
      <div class="flex items-center shrink-0">
        <img src="logo.png" alt="" class="w-10" />
        <p class="p-0 m-0 leading-none mx-2">
          <b class="text-primary-900">Sistema&nbsp;</b>
          <span style="font-weight: 700; color: gray">de gestión digital</span>
        </p>
      </div>
    } @else {
      <img src="logo.png" alt="" class="h-9 w-auto shrink-0" />
    }
  }
  <div
    class="lg:hidden md:hidden flex justify-start items-center pr-1"
  >
    @if (hasSidebar) {
      <c-button-animated [(collapse)]="collapse" />
    }
  </div>
  <div class="flex items-center gap-4 flex-1 min-w-0">
    <div class="flex-1 min-w-0">
      <div class="flex items-center gap-1.5 mb-0.5 mt-1.5">
        @for (item of breadcrumb; track $index; let last = $last) {
          <small class="text-slate-400 font-medium text-xs capitalize">
            {{ item }}
          </small>
          @if (!last) {
            <small class="text-slate-300 text-xs">›</small>
          }
        }
      </div>
      <div class="flex items-center gap-2">
        <h1 class="lg:text-3xl md:text-xl sm:text-base truncate">
          <b class="text-primary">{{ titulo }}</b>
          <span class="text-sm md:text-base font-normal text-slate-400">
            {{ subtitulo }}
          </span>
        </h1>
      </div>
    </div>
    <div class="flex items-center shrink-0">
      <div class="flex items-center gap-3">
        @if (isTestEnvironment) {
          <petrol-badge status="warning">Testing</petrol-badge>
        }
        <petrol-icon-button
          variant="flat"
          icon="pi-ticket"
          ariaLabel="Tickets"
          routerLink="/tickets"
          pTooltip="Tickets"
          tooltipPosition="bottom"
        />

        <div class="relative">
          <petrol-icon-button
            variant="flat"
            icon="pi-bell"
            ariaLabel="Notificaciones"
            (click)="toggleNotifOpen($event)"
            [attr.aria-expanded]="notifOpen"
          />
          @if (notif.hasNotificaciones()) {
            <span
              class="absolute top-1 right-1 w-2 h-2 rounded-full bg-danger border-2 border-white pointer-events-none"
            ></span>
          }

          <div
            class="absolute left-1/2 -translate-x-1/2 top-full mt-2 bg-white w-80 border border-slate-200 rounded-md shadow-lg overflow-hidden z-2000"
            [class.hidden]="!notifOpen"
            (click)="$event.stopPropagation()"
          >
            <c-notifications #notif />
          </div>
        </div>

        <div class="w-px h-6 bg-slate-200 mx-1"></div>

        <!-- Perfil: avatar + desplegable -->
        <div class="relative" (click)="$event.stopPropagation()">
          <button
            type="button"
            class="flex items-center gap-2 rounded-full pr-3 pl-1 py-1 hover:bg-slate-50 transition-colors"
            (click)="toggleProfileMenu($event)"
            aria-haspopup="true"
            [attr.aria-expanded]="profileMenuOpen"
          >
            <div
              class="w-8 h-8 rounded-full bg-slate-200 overflow-hidden shrink-0"
            >
              <img
                id="profile-img"
                class="w-full h-full object-cover"
                [src]="imgProfile"
                (error)="$event.target.src = 'svg/profile.svg'"
                alt=""
              />
            </div>
            <span class="lg:inline hidden text-sm font-medium text-slate-700 whitespace-nowrap">
              {{ usuario?.nombre }} {{ usuario?.apellido }}
            </span>
            <i
              class="pi pi-chevron-down text-[10px] text-slate-400 transition-transform"
              [class.rotate-180]="profileMenuOpen"
              aria-hidden="true"
            ></i>
          </button>

          @if (profileMenuOpen) {
            <div
              class="absolute right-0 top-full mt-2 w-56 bg-white border border-slate-200 shadow-lg py-1 z-2000"
            >
              <a
                [routerLink]="userPanelRoute"
                class="flex items-center gap-2 px-4 py-2 text-sm text-slate-700 hover:bg-slate-50"
              >
                <i class="pi pi-user text-[13px]" aria-hidden="true"></i>
                Mi Perfil
              </a>
              @if (hasSidebar || !isHomeSelector()) {
                <a
                  routerLink="/home"
                  class="flex items-center gap-2 px-4 py-2 text-sm text-slate-700 hover:bg-slate-50"
                >
                  <i class="pi pi-th-large text-[13px]" aria-hidden="true"></i>
                  Selección de sistema
                </a>
              }
              <div class="border-t border-slate-100 my-1"></div>
              <button
                type="button"
                (click)="logout()"
                class="w-full flex items-center gap-2 px-4 py-2 text-sm text-danger hover:bg-danger/5"
              >
                <i class="pi pi-sign-out text-[13px]" aria-hidden="true"></i>
                Cerrar Sesión
              </button>
            </div>
          }
        </div>
      </div>
    </div>
  </div>
</div>

<div
  class="duration-200 transition-all lg:hidden md:hidden"
  [ngClass]="{ 'w-full h-screen': collapse, 'w-0 h-0': !collapse }"
>
  <div class="bg-white w-full h-screen max-h-[91%]">
    <!-- Acá se replican los menus del sidebar -->
    @if (collapse) {
      <div
        animate.enter="fade-enter"
        animate.leave="fade-leave"
        style="--time: 50ms"
      >
        <div class="flex justify-between items-center p-3 flex-col">
          <img src="logo.png" alt="" class="w-14 rounded-full mb-2" />
          <p class="p-0 m-0 leading-none">
            <b class="text-primary">Sistema</b>
            de gestión digital
          </p>
        </div>

        <div class="p-3">
          <hr />
        </div>

        <div class="py-3 w-full">
          @if (hasSidebar) {
            @for (m of menu; track $index) {
              <c-item
                [isForRoot]="m.isForRoot!"
                [titulo]="m.titulo"
                [iconoActivo]="m.iconoActivo"
                [iconoInactivo]="m.iconoInactivo"
                [routerLink]="m.routerLink"
                [collapse]="false"
                (click)="collapse = false"
              />
            }
          }

          <div
            class="w-full flex justify-start items-center cursor-pointer transition-all duration-200"
            routerLink="/home"
          >
            <div class="w-5 h-5 relative overflow-hidden mr-2">
              <img
                src="svg/switch-fill.svg"
                alt="Icon"
                class="icon absolute top-0 left-0 transition-all duration-150 h-5 object-cover w-5"
              />
            </div>
            <a class="transition-all duration-200 text-unselected">
              Cambiar sistema
            </a>
          </div>

          <div
            class="w-full flex justify-start items-center cursor-pointer transition-all duration-200 mt-3"
            (click)="logout(); collapse = false"
          >
            <div class="w-5 h-5 relative overflow-hidden mr-2">
              <img
                src="svg/logout.svg"
                alt="Icon"
                class="icon absolute top-0 left-0 transition-all duration-150 h-5 object-cover w-5"
              />
            </div>
            <a class="transition-all duration-200 text-unselected">
              Cerrar sesión
            </a>
          </div>
        </div>
      </div>
    }
  </div>
</div>

<c-dialog #dialog />
